// ----------------------------------------------------------------------
// Stripe Connect Translations - Italian
// ----------------------------------------------------------------------

export const stripeConnectIt = {
  stripe_connect: {
    // Account selector
    select_account: 'Seleziona account Stripe',
    destination_account: 'Account di destinazione',
    no_accounts_available: 'Nessun account Stripe disponibile per i trasferimenti. Configura un account Stripe nelle impostazioni dell\'organizzazione.',
    personal_account: 'Account personale',
    organization_account: 'Account organizzazione',
    transfer_destination: 'Destinazione del trasferimento',
    transfer_helper_text: 'La quota del proprietario verrà trasferita su questo account dopo l\'evento',
    select_account_for_transfer: 'Seleziona quale account Stripe deve ricevere la quota del proprietario',

    // Account status
    status_active: 'Attivo',
    status_pending: 'In attesa',
    status_inactive: 'Inattivo',

    // Alerts and messages
    legal_verification: 'Verifica legale richiesta',
    complete_stripe_setup: 'Completa configurazione Stripe',
    complete_setup_short: 'Completa',
    setup_stripe_account: 'Configura account Stripe',
    setup_short: 'Configura',
    alert_stripe_incomplete_setup: 'La configurazione del tuo account Stripe è incompleta. Completa la verifica per ricevere pagamenti.',
    alert_stripe_configuration_title: 'È necessario un account Stripe Connect per ricevere pagamenti per i tuoi eventi.',

    // Multi-account messages
    no_stripe_for_org: 'Nessun account Stripe per questa organizzazione',
    no_stripe_for_org_named: 'Nessun account Stripe per "{{orgName}}"',
    using_personal_account_disclaimer: 'Utilizzo del tuo account Stripe personale.',
    configure_org_account: 'Configura account organizzazione',
    has_stripe_on_other_orgs: 'Hai account Stripe in altre organizzazioni. Configura questa organizzazione per usare un account esistente o creane uno nuovo nelle impostazioni dell\'organizzazione.',
    has_legacy_account: 'Hai un account Stripe personale. Abilitalo per questa organizzazione o creane uno nuovo nelle impostazioni dell\'organizzazione.',
    configure_in_settings: 'Configura nelle impostazioni',
    setup_in_org_settings: 'Configura gli account Stripe nelle impostazioni dell\'organizzazione',
    personal_account_available: 'Account Stripe personale disponibile',
    personal_account_hint: 'Hai un account Stripe personale che può essere abilitato per "{{orgName}}". Vai alle impostazioni dell\'organizzazione per configurare gli account di pagamento.',
    org_setup_incomplete_personal_available: 'Configurazione pagamenti organizzazione incompleta',
    org_setup_incomplete_personal_hint: 'La configurazione Stripe per "{{orgName}}" non è ancora completa. Il tuo account personale viene utilizzato nel frattempo. Completa la configurazione dell\'organizzazione quando preferisci.',
    alert_stripe_incomplete_setup_org: 'La configurazione dell\'account Stripe per "{{orgName}}" è incompleta. Completa il processo di verifica per iniziare a ricevere pagamenti per i tuoi eventi.',
    alert_stripe_configuration_org: 'Per ricevere pagamenti per eventi in "{{orgName}}", devi configurare un account Stripe Connect. Questo è obbligatorio per la conformità legale e l\'elaborazione sicura dei pagamenti.',

    // Stripe accounts manager
    stripe_accounts: 'Account Stripe',
    stripe_accounts_subtitle: 'Gestisci gli account Stripe Connect per questa organizzazione',
    add_account: 'Aggiungi account',
    add_new_account: 'Aggiungi nuovo account',
    sync_account: 'Sincronizza account',
    set_as_primary: 'Imposta come principale',
    deactivate_account: 'Disattiva account',
    edit_account: 'Modifica account',
    account_name: 'Nome account',
    account_description: 'Descrizione',
    account_name_placeholder: 'es: Account principale, Account festival',
    account_description_placeholder: 'Descrizione opzionale per questo account',
    primary_account: 'Account principale',
    primary_account_badge: 'Principale',

    // Account stats
    total_accounts: 'Totale account',
    active_accounts: 'Account attivi',
    pending_accounts: 'Account in attesa',
    inactive_accounts: 'Account inattivi',

    // Account details
    account_id: 'ID account',
    charges_enabled: 'Addebiti abilitati',
    payouts_enabled: 'Pagamenti abilitati',
    details_submitted: 'Dettagli inviati',
    country: 'Paese',
    currency: 'Valuta',
    business_type: 'Tipo di attività',
    last_synced: 'Ultima sincronizzazione',
    created_at: 'Creato il',
    created_by: 'Creato da',

    // Actions
    complete_onboarding: 'Completa registrazione',
    view_dashboard: 'Visualizza dashboard Stripe',
    refresh_status: 'Aggiorna stato',

    // Confirmations
    confirm_deactivate: 'Sei sicuro di voler disattivare questo account?',
    confirm_deactivate_description: 'Gli account disattivati non possono ricevere pagamenti. Puoi riattivarli in seguito.',
    confirm_set_primary: 'Impostare questo account come principale?',
    confirm_set_primary_description: 'L\'account principale verrà utilizzato di default per i nuovi eventi.',

    // Success messages
    account_created: 'Account Stripe creato con successo',
    account_updated: 'Account Stripe aggiornato con successo',
    account_synced: 'Stato dell\'account sincronizzato con successo',
    account_deactivated: 'Account disattivato con successo',
    primary_account_set: 'Account principale aggiornato con successo',

    // Error messages
    error_creating_account: 'Errore durante la creazione dell\'account Stripe',
    error_updating_account: 'Errore durante l\'aggiornamento dell\'account Stripe',
    error_syncing_account: 'Errore durante la sincronizzazione dello stato dell\'account',
    error_deactivating_account: 'Errore durante la disattivazione dell\'account',
    error_setting_primary: 'Errore durante l\'impostazione dell\'account principale',
    error_creating_stripe_link: 'Errore durante la creazione del link di registrazione Stripe',
    error_creating_stripe_account: 'Errore durante la creazione dell\'account Stripe',

    // Legacy account
    use_legacy_account: 'Usa account personale',
    use_legacy_account_description: 'Usa il tuo account Stripe personale quando non è disponibile un account dell\'organizzazione',
    legacy_account_active: 'Il tuo account Stripe personale è attivo e può essere utilizzato',
    legacy_account_pending: 'Il tuo account Stripe personale richiede una verifica aggiuntiva',
  },

  // Shares distribution (new keys - existing keys like shares_distribution, reservation_details, reservations are in main locale)
  shares_distribution_subheader: 'Panoramica della distribuzione dei ricavi per questo evento',
  total_sales: 'Vendite totali',

  // Common
  this_organization: 'questa organizzazione',
};

export default stripeConnectIt;
